export default __webpack_public_path__ + "static/media/polygonchain.5c03b425.svg";